module.exports = __webpack_public_path__ + "img/haipaike.fbd0a316.png";